import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import Button from '../Button';
var INDENT = 20; // 树形缩进值

var BTNWIDTH = 24; // 按钮宽度

var TableTreeCell = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableTreeCell, _React$PureComponent);

  var _super = _createSuper(TableTreeCell);

  function TableTreeCell() {
    _classCallCheck(this, TableTreeCell);

    return _super.apply(this, arguments);
  }

  _createClass(TableTreeCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          expanded = _this$props.expanded,
          data = _this$props.data,
          text = _this$props.text,
          onClick = _this$props.onClick;
      var children = data.children,
          render = data.render,
          level = data._roo_level;
      var hashChildren = children && children.length > 0; // 20 为缩进，24 为按钮大小

      var indent = (level || 0) * INDENT;
      indent = !hashChildren ? indent + BTNWIDTH : indent;
      var indentStyle = {
        paddingLeft: indent
      };
      var content = expanded ? '-' : '+';
      return /*#__PURE__*/React.createElement("span", {
        style: indentStyle
      }, hashChildren ? /*#__PURE__*/React.createElement(Button, {
        style: {
          width: '18px',
          padding: '0',
          lineHeight: '16px',
          marginRight: '6px'
        },
        type: "hollow",
        size: "mini",
        onClick: onClick
      }, /*#__PURE__*/React.createElement("span", null, content)) : null, /*#__PURE__*/React.createElement("span", null, render ? render(text, data, data._roo_index) : text));
    }
  }]);

  return TableTreeCell;
}(React.PureComponent);

export { TableTreeCell as default };